var render = function (_h,_vm) {var _c=_vm._c;return _c('section',[_c('p',{staticClass:"fs-s"},[_vm._v(" © "+_vm._s(new Date().getFullYear())+" Sašo Marković. All rights reserved. ")])])}
var staticRenderFns = []

export { render, staticRenderFns }